import { LoadingIndicator, LocalesMenuButton } from 'react-admin';
import { Box, Divider, alpha } from '@mui/material';

import { ThemeSwapper } from '../common/themes/ThemeSwapper';
import { appBarColors } from './appBarTheme';

/**
 * The right-hand controls, gathered into one translucent pill.
 *
 * They were three loose icons sitting directly on the bar with nothing tying
 * them together. Grouping them reads as a control cluster and separates them
 * from the user menu, which is a different kind of thing -- who you are, not
 * what the panel is doing.
 */
export const AppBarToolbar = () => (
    <Box
        sx={theme => {
            const { fg } = appBarColors(theme);
            return {
                display: 'flex',
                alignItems: 'center',
                gap: 0.25,
                mr: 1,
                px: 0.5,
                borderRadius: 999,
                bgcolor: alpha(fg, 0.12),
                border: `1px solid ${alpha(fg, 0.2)}`,
                '& .MuiIconButton-root, & .MuiButton-root': { color: fg },
            };
        }}
    >
        <LocalesMenuButton />
        <Divider
            orientation="vertical"
            flexItem
            sx={theme => ({ my: 1, borderColor: alpha(appBarColors(theme).fg, 0.25) })}
        />
        <ThemeSwapper />
        <LoadingIndicator />
    </Box>
);
